<template>
  <button
    :class="btnClass"
    :type="type"
    :primary="primary"
    :secondary="secondary"
    :danger="danger"
    :icon="icon"
    :disabled="disabled"
  >
    <slot/>
  </button>
</template>

<script>
import ButtonMixin from '@/Mixins/ButtonMixin'

export default {
  mixins: [ButtonMixin],

  name: "ActionButton",
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      default: 'button'
    }
  },
};
</script>
